export const getPageId = () => {
    const href = window.location.href;
    const id = href.split("/").pop() || "";
    if (Number.isNaN(parseInt(id || ""))) {
        return "";
    }
    return id;
};
